<template>
  <div class="content--sinoreg page--CadastroServentia CadastrarServentia">
    <header-blue>
      <h4 class="pl-2">
        <svg class="obito-show_icon icon--md"
             role="presentation">
          <use :xlink:href="'#' + config.id" />
        </svg>
        <span class="pt-3">
          Cadastro de Serventia
        </span>
      </h4>
    </header-blue>

    <b-tabs v-model="tabIndex"
            content-class="mt-3"
            class="CadastrarServentia-border"
            align="left"
            active-nav-item-class="CadastrarServentia--tab-active"
            no-body>
      <b-tab active
             title="Cartório">
        <CartorioServentia :tab-active="tabIndex" />
      </b-tab>

      <b-tab title="Usuários">
        <UsuariosServentia :tab-active="tabIndex" />
      </b-tab>

      <b-tab title="Grupos de Acesso">
        <ServentiaAcessGroups :tab-active="tabIndex" />
      </b-tab>

      <b-tab title="Acervos"
             :active="propConfigLivro || $route.query.acao == 'protocolo'">
        <AcervosServentia :tab-active="tabIndex" />
      </b-tab>

      <b-tab title="Preferências">
        <PreferenciasServentia :tab-active="tabIndex" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import CartorioServentia from '@/components/SofiaRei/Serventia/CartorioServentia.vue'
  import UsuariosServentia from '@/components/SofiaRei/Serventia/UsuariosServentia.vue'
  import AcervosServentia from '@/components/SofiaRei/Serventia/AcervosServentia.vue'
  import PreferenciasServentia from '@/components/SofiaRei/Serventia/PreferenciasServentia.vue'
  import ServentiaAcessGroups from '@/components/SofiaRei/Serventia/ServentiaAcessGroups.vue'
  import { mapGetters } from 'vuex'
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import config from '@/assets/icons/config-user.svg?sprite'

  export default {
    name: 'CadastrarServentia',
    components: {
      ServentiaAcessGroups,
      CartorioServentia,
      UsuariosServentia,
      AcervosServentia,
      PreferenciasServentia,
      HeaderBlue,
    },
    props: {
      propConfigLivro: { type: Boolean, defalt: false }
    },
    data () {
      return {
        tabIndex: 0,
        config
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
      })
    },
    methods: {},
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';

  .title {
    &--secondary {
      background-color: lighten($primary-color, 4.5%);
      color: $color-white;
      font-size: pxToRem(16);
      font-weight: 500;
      margin-top: pxToRem(-14);
      padding: pxToRem(10) pxToRem(20);
    }
  }


  .CadastrarServentia {
    &--header {
      background-color: #01bfa5;
      border-radius: 5px 5px 0 0;
      font-size: 15px;
      font-weight: bold;
      height: 50px;
    }

    &--item {
      border-bottom: 1px solid black;
      border-left: 1px solid black;
      border-right: 1px solid black;
      padding: 8px 0;
    }

    &--item input {
      text-align: center;
      max-width: 90px;
    }

    & .nav-link {
      border: 1px solid $sinoreg-blue;
      color: $color-black;
      font-size: pxToRem(15);
      border-radius:0;
    }
    & .nav-link:hover {
      border: 1px solid #696969;
      color: $color-black;
    }
    &--tab-active {
      background-color: $sinoreg-blue !important;
      border: 1px solid $sinoreg-blue !important;
      color: white !important;
      fill: white !important;
    }
    &-border ul.nav {
      border-bottom: 3px solid $sinoreg-blue !important;
    }
    &-border ul.nav > li > a,
    &-border ul.nav > li > a:hover {
      border-bottom: 0 solid $sinoreg-blue;
      border-right: 1px solid white;
      border-left: 1px solid white;
      border-top: 1px solid white;
    }

    .btn-danger {
      background-color: #8B0000;
      border-color: #8B0000
    }

    .btn-primary {
      background-color: #086AAE;
      border-color: #086AAE
    }
    .btn-outline-secondary > svg {
      fill: #086AAE
    }
    .btn-outline-secondary:hover > svg {
      fill: white
    }
    .btn-outline-secondary:hover {
      background-color: #086AAE;
      border-color: #086AAE

    }
  }

  .thead {
    &--green {
      @extend %thead--variation;
      background-color: $color-light-green;
    }
  }

  .text {
    &--return {
      border-style: dashed !important;
      margin: pxToRem(12) auto;
      padding: pxToRem(12);
    }
  }
</style>
